import React, { useState, useEffect } from "react";
import { Card } from "reactstrap";
import { toast } from "react-toastify";
import DashboardCardHeader from "./dashboardCardHeader";
import { getTicketList } from "../../api/casp/ticket";
import SettingsIcon from "../../assets/images/icons/greenSetting_svg.svg";
import Loader from "../Common/Loader";
import NodataFound from "../Common/NoDataFound";
import MilestoneIcon from "../../assets/images/icons/achieve.png";
import { MemberIcon } from "../../constants/MemberIcon";
import moment from "moment";
import PriorityIcon from "../../Components/Icon/priority";
import StatusBadge from "../Badge/statusBadge";
import { useLocation, useNavigate } from "react-router-dom";
import AssignmentIcon from '@mui/icons-material/Assignment';
import UserProfile from "../casp/common/userProfile";
import Tooltip from '@mui/material/Tooltip';
import Avatar from "@mui/material/Avatar";
import { withTranslation } from "react-i18next";

const TaskList = ({ projectId, t }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (projectId) {
      getTaskList();
    }
  }, []);

  const getTaskList = async () => {
    try {
      setIsLoading(true);
      const res = (
        await getTicketList({
          page: 1,
          perPage: 10,
          projectId,
          projectIds: [projectId],
          order: 'updatedAt',
          direction: 'asc',
        })
      ).data.data;
      setTaskList(res.data);
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Card className="customCard recentTaskCard dashboardRecentCard p-3">
        <div className="recentTaskHeader d-flex justify-content-between align-items-center">
          <DashboardCardHeader title={t("Recent Tasks")} borderBottom="true" fontSize="18px" />
          {/* <button className='edit_button d-flex justify-content-center'>Status</button> */}
        </div>
        <div
          style={{
            height: "230px",
            overflow: taskList.length ? "auto" : "hidden",
          }}
        >
          {taskList.length > 0 && !isLoading && (
            <ul className="recentTaskListing p-0 list-inline">
              {taskList.map((item, index) => (
                <li key={index}>
                  <div className="singleRecentTask mx-2 d-grid five_grid_cols justify-content-between align-items-center">
                    <div className="taskBasicDetail d-flex align-items-center">
                      {/* <AssignmentIcon /> */}
                      {/* <img src={SettingsIcon} alt={SettingsIcon} /> */}
                      <div className="taskName text-truncate" title={item.name} style={{ width:'230px'}}>
                        <span style={{ cursor: "pointer" }} onClick={() =>
                          navigate(`/project/${projectId}/ticket/${item.id}`, {
                            from: location.pathname,
                          })
                        }>{item.name}</span>
                      </div>
                    </div>
                    {/* <div className="taskOtherDetail d-flex align-items-center"> */}
                      <div className="teamPersonName mx-2">{item.startDate ? moment(item.startDate).format("Do MMMM, YYYY") : ''}</div>
                      <Tooltip title={item?.assignee?.name ?? t('Unassign')}>
                        <UserProfile user={item?.assignee} avatarClassName="me-2" profileClassName="me-2" tooltip={true} />
                      </Tooltip>

                      {/* <UserProfile user={item?.assignee} profileStyle ={{height: '32px', width: '32px', fontSize: '15px'}} tooltip={true}/> */}
                      <div className="statusChip">
                        {/* <StatusBadge label={item?.status?.name} color={item?.status?.color}/> */}
                        <span style={{ color: item?.status?.color, fontSize: '12px', padding: '4px', background: item?.status?.color ? item?.status?.color + '33'  :'#EBEDF533' }}>{item?.status?.name}</span>
                      </div>
                      <div className="dashTaskPriority">
                        <PriorityIcon IconColor={item?.priority?.color} label={item?.priority?.name}/>
                      </div>
                    {/* </div> */}
                  </div>
                </li>
              ))}
            </ul>
          )}

          {isLoading && <Loader />}
          {taskList.length === 0 && !isLoading && (
            <NodataFound text={t("No tickets to show")} icon={MilestoneIcon} />
          )}
        </div>
      </Card>
    </React.Fragment>
  );
}

export default withTranslation() (TaskList)
